import React from 'react';
import PropTypes from 'prop-types';
import './teacherCommentModal.scss';
import Modal from '../../../../../../../../components/Modal';

function ViewAllStudentAnswerModal(props) {
  return (
    <Modal isOpen={props.show} onClose={props.onHide} contentWidth="800px" titleName="Answer">
      <div style={{ maxHeight: '70vh' }}>
        <div
          dangerouslySetInnerHTML={{ __html: props.studentAnswer }}
          style={{ height: '100%' }}></div>
      </div>
    </Modal>
  );
}

ViewAllStudentAnswerModal.propTypes = {
  studentAnswer: PropTypes.string,
  show: PropTypes.func,
  onHide: PropTypes.any
};

export default ViewAllStudentAnswerModal;
